import React from 'react';
import ActivityPanel from '../../../module/shop/dashboard/activityPanel';

const Home = () => {
  return (
    <div className="mt-4 px-3">
      <div>
        <ActivityPanel />
      </div>
    </div>
  );
};

export default Home;
